"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconAlertNotification = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconAlertNotification = function IconAlertNotification(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.72 13.174a.502.502 0 01.007.87l-16.455 9.5a.499.499 0 01-.75-.442l.056-3.337a8.506 8.506 0 00-1.137-4.393l-1.254-2.17c-1.582-2.742-1.092-6.116.978-8.308L3.268 3.34A2.002 2.002 0 014 .608a2.002 2.002 0 012.732.732l.897 1.554c2.933-.696 6.1.566 7.683 3.307l1.254 2.171a8.501 8.501 0 003.236 3.182l2.918 1.62zM12.402 21.16l6.062-3.5c.046 1.334-.692 2.71-2.031 3.482-1.339.773-2.9.725-4.031.018z"
  }));
};
exports.IconAlertNotification = IconAlertNotification;